<template>
    <div class="xinzeng">
        <div class="xinzengc">
            <van-cell-group>
				
                <van-field v-model="xzlist.name" label="姓名" placeholder="请输入姓名" input-align="right" required ></van-field>
                <van-field v-model="xzlist.mobile" label="联系方式" placeholder="请输入联系方式" input-align="right" required type="number"></van-field>
				<van-field v-model="xzlist.title" label="投诉名称" placeholder="请输入投诉名称" input-align="right" required ></van-field>
	<!-- 			<van-field v-model="xzlist.respondentsName" label="投诉对象姓名" placeholder="请输入投诉对象姓名" input-align="right" required ></van-field>
                <van-cell is-link @click="showfl = true" :value="depttext" title="投诉对象企业" v-show="qiye.length>0"></van-cell>
                <van-popup v-model="showfl" round position='bottom' >
                    <van-picker
                        show-toolbar
                        :columns="qiye"
                        @confirm="onConfirmfl"
                        @cancel="showfl = false"
                    />
                </van-popup>
                <van-cell is-link @click="showsx = true" :value="respondentstext" title="选择企业员工"  v-show="yuangong.length>0"></van-cell>
                <van-popup v-model="showsx" round position='bottom' >
                    <van-picker
                        show-toolbar
                        :columns="yuangong"
                        @confirm="onConfirmsx"
                        @cancel="showsx = false"
                    />
                </van-popup> -->
				<!-- <van-field name="radio" label="投诉类型" required>
						<template #input>
							<van-radio-group v-model="xzlist.type" direction="horizontal" @change="changeType">
								<van-radio :name="item.id" v-for="(item,i) in types">{{item.text}}</van-radio>
							</van-radio-group>
						</template>
				</van-field> -->
                <van-cell is-link @click="showfl = true" :value="xzlist.type" title="投诉类型" required></van-cell>
                <van-popup v-model="showfl" round position='bottom' >
                    <van-picker
                        show-toolbar
                        :columns="fenlei"
                        @confirm="onConfirmfl"
                        @cancel="showfl = false"
                    />
                </van-popup>


                 <van-field v-model="xzlist.content" label="详细描述" placeholder="描述" input-align="right" required type="textarea"></van-field>
				 <div class="shangchuan">
				     <div class="sctitle">
				         <span class="" >图片</span>
				     </div>
				     <van-uploader :after-read="imgPreview" multiple  v-model="attachs" style="width:85%"></van-uploader>
				 </div>
                  <van-field v-model="xzlist.address" label="投诉地址" placeholder="请输入投诉地址" input-align="right" required ></van-field>
              </van-cell-group>
            <div class="bt md20">
                <button @click="add()" class="btn">提交</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Vue from 'vue';
import {
	RadioGroup,
	Radio,
} from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
    data() {
        return {
           showfl:false,
           fenlei:[],
           /* showsx:false,
           qiye:[],
           yuangong:[], */
		   types:[],//投诉类型
           xzlist:{
			   title:'',
               name:'',
               mobile:'',
			   type:'',//投诉类型
			   // respondentsName:'',
               content:'',
               address:''
           },
		  /* deptId:'',
		   depttext:'',
		   respondentsId:'',
		   respondentstext:'', */
           attachs:[]
        }
    },
    mounted() {
        var userinfo=JSON.parse(localStorage.getItem('userInfo'));
		console.log("🚀 ~ file: tousu.vue:98 ~ mounted ~ this.userInfo:", this.userInfo)
		this.xzlist.name=this.userInfo.trueName||userinfo.userName;
		this.xzlist.mobile=this.userInfo.phone||userinfo.phonenumber;
		this.xzlist.address=this.address||'';
		this.$axios.get('/api/v1/complaint/dicts').then(res=>{
			console.log(res)
			// this.types=res.types
            			res.types.map(item=>{
				this.fenlei.push({
					text: item.text,
					value:item.id
				})
			})
		})
		/* this.$axios.get('/api/v1/common/house/'+this.houseId+'/companys').then(res=>{
			console.log(res)
			res.map(item=>{
				this.qiye.push({
					text: item.deptName,
					value:item.deptId
				})
			})
		}) */
    },
    computed: {
    	...mapState(['userInfo','identity','houseId','address']),
    },
    methods: {
		add(){
			var pass=true;
			for(var key in this.xzlist){
				if(!this.xzlist[key]){
					pass=false;
					break;
				}
			}
			
			if(!pass){
				this.$dialog({ message: '您还有信息未填' })
				return
			}
            this.xzlist.type=this.xzlist.typeId
			this.$axios.post('/api/v1/complaint',{
					houseId:this.houseId,
					...this.xzlist,
					// deptId:this.deptId,
					// respondentsId: this.respondentsId,
					attachs:this.attachs.map(item=>{
                        return {id:item.id}
                    })
			}).then(res=>{
				console.log(res)
				this.$dialog({ message: '提交成功' }).then(() => {
					this.$router.go(-1)
				});
			})
		},
		changeType(e){
			console.log(e)
		},
		// 处理图片
        imgPreview(file) {
            let arr = []
            let self = this
            let Orientation
            if(file.length == undefined){
               var fobj = file
               arr.push(fobj)
            }else{
               file.forEach(item=>{
                arr.push(item)
               })
            }
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return
            arr.map(item=>{
                if (/^image/.test(item.file.type)) {
                    // 创建一个reader
                    let reader = new FileReader()
                    // 将图片2将转成 base64 格式
                    let name = item.file.name
                    reader.readAsDataURL(item.file)
                    // 读取成功后的回调
                    var nf = null
                    reader.onloadend = function() {
                        let result = this.result
                        let img = new Image()
                        img.src = result
                        //判断图片是否大于200K,是就直接上传，反之压缩图片
                        if (this.result.length <= 200 * 1024) {
                            // 上传图片
                            console.log('正好')
                            item.file = self.dataURLtoFile(this.result,name)
                            self.afterRead(item)
                        } else {
                            console.log('大图')
                            img.onload = function() {
                                let data = self.compress(img, Orientation)
                                item.file  = self.dataURLtoFile(data,name)
                                self.afterRead(item)
                            }
                        }
                    }
                }
            })
            this.$emit('childimglist',self.xczk)
        },
        //将base64转换为文件
        dataURLtoFile(dataurl, filename) { 
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        // 压缩图片
        compress(img, Orientation) {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            //瓦片canvas
            let tCanvas = document.createElement('canvas')
            let tctx = tCanvas.getContext('2d')
            // let initSize = img.src.length;
            let width = img.width
            let height = img.height
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio
            if ((ratio = (width * height) / 4000000) > 1) {
                // console.log("大于400万像素");
                ratio = Math.sqrt(ratio)
                width /= ratio
                height /= ratio
            } else {
                ratio = 1
            }
            canvas.width = width
            canvas.height = height
            //    铺底色
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            //如果图片像素大于100万则使用瓦片绘制
            let count
            if ((count = (width * height) / 1000000) > 1) {
                // console.log("超过100W像素");
                count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
                //      计算每块瓦片的宽和高
                let nw = ~~(width / count)
                let nh = ~~(height / count)
                tCanvas.width = nw
                tCanvas.height = nh
                for (let i = 0; i < count; i++) {
                for (let j = 0; j < count; j++) {
                    tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
                    ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
                }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height)
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != '' && Orientation != 1) {
                switch (Orientation) {
                case 6: //需要顺时针（向左）90度旋转
                    this.rotateImg(img, 'left', canvas)
                    break
                case 8: //需要逆时针（向右）90度旋转
                    this.rotateImg(img, 'right', canvas)
                    break
                case 3: //需要180度旋转
                    this.rotateImg(img, 'right', canvas) //转两次
                    this.rotateImg(img, 'right', canvas)
                    break
                }
            }
            //进行最小压缩
            let ndata = canvas.toDataURL('image/jpeg', 0.15)
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            return ndata
        },
        // 旋转图片
        rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            const min_step = 0
            const max_step = 3
            if (img == null) return
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            let height = img.height
            let width = img.width
            let step = 2
            if (step == null) {
                step = min_step
            }
            if (direction == 'right') {
                step++
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step)
            } else {
                step--
                step < min_step && (step = max_step)
            }
            //旋转角度以弧度值为参数
            let degree = (step * 90 * Math.PI) / 180
            let ctx = canvas.getContext('2d')
            switch (step) {
                case 0:
                canvas.width = width
                canvas.height = height
                ctx.drawImage(img, 0, 0)
                break
                case 1:
                canvas.width = height
                canvas.height = width
                ctx.rotate(degree)
                ctx.drawImage(img, 0, -height)
                break
                case 2:
                canvas.width = width
                canvas.height = height
                ctx.rotate(degree)
                ctx.drawImage(img, -width, -height)
                break
                case 3:
                canvas.width = height
                canvas.height = width
                ctx.rotate(degree)
                ctx.drawImage(img, -width, 0)
                break
            }
        },
		//上传照片的接口
        afterRead(file){
            var that = this
            let content = file.file;
            let data = new FormData();
            data.append('file',content);
            data.append('moduleCode','tsbx_complaint');
            data.append('moduleName','业主投诉申请');
            file.status= 'uploading',
            file.message= '上传中...'
            let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
			   };
            this.$axios.post('/api/v1/common/upload',data, config)
            .then(result=>{
                if(result.id){
                    file.srcs = result.webUrl
                    file.status = 'done'
                    file.message =''
                    file.id = result.id
                }else{
                    that.$toast.fail('图片上传失败，请重试！');
                    file.status='failed'
                    file.message= '上传失败'
                }
            })
        },
        // 企业
        onConfirmfl(value){
            this.xzlist.typeId = value.value;
			this.xzlist.type = value.text;
            this.showfl = false
        },
        // 企业的员工
        onConfirmsx(value){
            this.respondentsId = value.value;
        	this.respondentstext = value.text;
            this.showsx = false;
        },
        
    },




}
</script>
<style lang="less" scoped="scoped">

.xinzeng{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
}
.van-field__label{
    width: 7.2em !important;
}
.van-checkbox-group{
    display: flex;
    justify-content: space-around;
}
.van-checkbox--horizontal{
    margin-top: 10px;
}
.van-cell{
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.bt{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.md20{
    margin-bottom: 20px;
}
.btn{
    margin-top: 30px;
    outline: none;
    border: none;
    border-radius: 10px;
    color: white !important;
    font-weight: 600;
    background: #28aff6;
    height: 40px;
    width: 70%;
    cursor: pointer;
}
.khtitle{
    margin-top: 10px;
    height: 24px;
    color: #666666;
    width: 100%;
    font-weight: 600;
    border-left: 4px solid #28aff6;
}
.khtitle span{
    margin-left: 5px;
}
input{
    color: #999999 !important;
}

.van-popup--center{
    top: 25% !important;
}
.van-uploader__wrapper{
    float:right;
    justify-content: space-between;
}

.sctitle{
    width: 30%;
}
.red{
    color: red;
}
.van-cell__title{
    color: #666666;
}
.shangchuan{
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
}
.shangchuan::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}
.xinzengc{
    width: calc(100% - 6%);
}
.van-radio-group{
    display: flex;
    justify-content: space-around;
}
.zctitle{
    margin-top: 10px;
    height: 24px;
    color: #666666;
    width: 100%;
    
}
.zctitle span{
    margin-left: 5px;
}
.scrollbar{
display:none
}

</style>